export default __webpack_public_path__ + "static/media/il-success.ef10b52f.png";